import { coordinateFromMap } from '../domain/coordinates';
import type { ElevationSample } from './demGrid';

export type ElevationReading = ElevationSample | { readonly status: 'unavailable' } | { readonly status: 'loading' };

export interface ElevationQuerySource {
  readonly status: 'idle' | 'loading' | 'ready' | 'error';
  sample(lon: number, lat: number): ElevationReading;
}

/** Elevation under a map (EPSG:3857) coordinate. Uses the exact inverse projection to WGS84, not a local approximation. */
export function elevationAtMapCoordinate(source: ElevationQuerySource, coordinate: readonly number[]): ElevationReading {
  if (source.status === 'loading' || source.status === 'idle') return { status: 'loading' };
  const { lon, lat } = coordinateFromMap(coordinate);
  return source.sample(lon, lat);
}

const metres = (value: number): string => `${value.toLocaleString('es-NI', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} m`;

/** "44.5 m", or a short reason when there is no terrain height. Never a number for water, gaps or outside coverage. */
export function formatElevationReading(reading: ElevationReading): string {
  switch (reading.status) {
    case 'ok': return metres(reading.elevation);
    case 'water': return 'Sin dato (agua)';
    case 'outside': return 'Sin dato (fuera de cobertura)';
    case 'loading': return 'Sin dato (cargando)';
    default: return 'Sin dato';
  }
}

export const formatMetres = metres;
